import { Box, Switch } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

const SyncSegmentsStatus = ({ segmentSync, i, toggleSegmentSync }) => {
  let status;

  if (segmentSync.isSyncing) {
    status = (
      <Box display="inline-block">
        <IconRefresh size={14} />
        <Box component="span" visibleFrom="md" display="inline"> Syncing...</Box>
      </Box>
    );
  } else {
    status = (
      <>
        <Box display="inline-block">
          <Switch
            size="lg"
            defaultChecked={segmentSync.running}
            onChange={(e) => toggleSegmentSync(i, e.target.checked)}
          />
        </Box>
      </>
    );
  }

  return <>{status}</>;
};

export default SyncSegmentsStatus;
